module.exports = __webpack_public_path__ + "img/social-icon.e33103ab.svg";